import MembershipDashboardPage from "./pages/MembershipDashboardPage";
import MemberDetailsPage from "./pages/MemberDetailsPage";
import MembershipBandsPage from "./pages/MembershipBandPage";
import MembershipManagement from "./pages/MembershipManagement";

export const membershipRoutes = [
  {
    // Privilege, not role — same gate as the sidebar link that leads here.
    path: "/membership-bands",
    element: <MembershipBandsPage />,
    perms: ["billing.band.access"],
  },
  {
    path: "/membership-dashboard",
    element: <MembershipDashboardPage />,
    // Permission alone: this screen shows what every member owes, so it is
    // gated by its own permission rather than by holding the admin role.
    perms: ["membership.analysis.access"],
  },
  {
    /*
     * The privilege the API enforces, and nothing else.
     *
     * These two read `GET /admin/membership/members` and `GET /members/{id}`,
     * the first of which runs on `permission:member.access` — so that
     * permission, held or not, already decides whether the screen has any
     * data in it.
     *
     * They were gated on `roles: ["admin", "president"]` instead, written
     * when `member.access` existed only where somebody had made the row by
     * hand; AnalysisPermissionSeeder now creates it and grants it to
     * super_admin, president and admin, so the fear it was guarding against
     * is gone. Meanwhile RequirePermission demands roles AND perms together,
     * which made the role list a hard ceiling: the treasurer was granted
     * `member.access`, saw the "Memberships" link the sidebar gates on that
     * same permission, and was bounced to /unauthorized by a gate asking a
     * different question. Any executive office given the register runs into
     * it, not just the treasurer.
     *
     * So: the permission alone, matching both the sidebar link and the
     * endpoint. Anyone this admits can actually read the register, and
     * anyone it turns away would have been refused by the API anyway.
     */
    path: "/member-list",
    element: <MembershipManagement />,
    perms: ["member.access"],
  },
  {
    // The list links straight to this page, so it carries the same gate —
    // otherwise the holder gets a list whose every row leads nowhere.
    path: "/member-list/:id",
    element: <MemberDetailsPage />,
    perms: ["member.access"],
  },
  {
    path: "/admin/members/:id/dues",
    element: <MemberDetailsPage />,
    roles: ["admin"],
  },
];
